





































import { defineComponent, PropType } from 'vue';
import upload from '../../../shared/components/Upload.vue';
import PluginTextEditor from '../text_editor/PluginTextEditor.vue';
import AulaInfoTrigger from '../../../shared/components/AulaInfoTrigger.vue';
import { parentTypes } from '../../../shared/enums/parentTypes';
import { AttachmentModel } from '../../../shared/models/attachment.model';
import { useFilePastedToEditor } from '../../../shared/composables/useFilePastedToEditor';

export default defineComponent({
  name: 'LessonNoteAttachmentsSection',
  components: {
    AulaInfoTrigger,
    PluginTextEditor,
    upload,
  },
  props: {
    editorId: { type: String, required: true },
    labelTextKey: { type: String, required: true },
    note: { type: String, default: '' },
    attachments: { type: Array as PropType<AttachmentModel[]>, default: () => [] },
    institutionCode: { type: String, required: true },
    parent: { type: String as PropType<parentTypes>, required: true },
    canCreateAttachments: { type: Boolean, required: true },
    canAttachFromSecureFiles: { type: Boolean, required: true },
    infoArea: { type: String, default: null },
    labelClass: { type: String, default: '' },
  },
  emits: ['update:note', 'update:attachments'],
  setup(_, { emit }) {
    const { onFilePastedToEditor } = useFilePastedToEditor();

    const updateNote = (value: string) => {
      emit('update:note', value);
    };

    const updateAttachments = (attachments: AttachmentModel[]) => {
      emit('update:attachments', attachments);
    };

    return {
      onFilePastedToEditor,
      updateNote,
      updateAttachments,
    };
  },
  methods: {
    attachSecureDocuments(documents) {
      this.$refs.uploaderFiles.addNewMedia(documents);
    },
  },
});
